import React from "react";
import styles from "./JoinCommunity.module.css";

const JoinCommunity = () => {
  return <div className={styles.join__community}>Join Community</div>;
};

export default JoinCommunity;
